module.exports = __webpack_public_path__ + "static/img/NSW-2.7e591fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-2.jpg
// module id = +59A
// module chunks = 0